// extracted by mini-css-extract-plugin
module.exports = {"dayHeader":"orderDay_dayHeader__2Dr6O","dayItems":"orderDay_dayItems__4QRTo","daySummary":"orderDay_daySummary__3ZRc8","daySubSummary":"orderDay_daySubSummary__1KzmU"};